import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_QUARTER_PATH_KEY } from '@/swagger/constants/credits-keys';
import {
  API_GET_ORGANIZATION_CREDITS_QUARTER,
  KEY_GET_ORGANIZATION_CREDITS_QUARTER,
} from '../constants';
import { MOCK_RESPONSE_GET_ORGANIZATION_CREDITS_QUARTER } from '../mocks';

type RequestGetOrganizationCreditsQuarter = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_QUARTER_PATH_KEY
>['request']['path'];

export type ResponseGetOrganizationCreditsQuarter = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_QUARTER_PATH_KEY
>['response']['body'];

export type CallParamsGetOrganizationCreditsQuarter = Omit<
  RequestGetOrganizationCreditsQuarter,
  'organizationId'
> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponseGetOrganizationCreditsQuarter = ResponseGetOrganizationCreditsQuarter;

type CallErrorGetOrganizationCreditsQuarter = {
  message: string;
  code: number;
};

type CallSelectorsGetOrganizationCreditsQuarter = {
  defaultQuarter?: string;
};

export const getOrganizationCreditsQuarterCall = createGeneralCall<
  CallParamsGetOrganizationCreditsQuarter,
  CallResponseGetOrganizationCreditsQuarter,
  CallErrorGetOrganizationCreditsQuarter,
  CallSelectorsGetOrganizationCreditsQuarter
>({
  id: KEY_GET_ORGANIZATION_CREDITS_QUARTER,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_GET_ORGANIZATION_CREDITS_QUARTER(org as unknown as string);
  },
  paramsSelector:
    ({ payload }) =>
    () => {
      return payload;
    },
  method: 'get',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_ORGANIZATION_CREDITS_QUARTER : undefined,
  selectors: {
    defaultQuarter: ({ selectors }) =>
      createSelector(
        selectors.response,
        res => (res && `${res[0]?.quarter}-${res[0]?.year}`) || undefined,
      ),
  },
});
